import { instances } from '@/services/http';
import { useQuery } from '@tanstack/vue-query';
import type { UserDashboardGetAllEventsResponseType } from '@magma-app/magma-types/user-dashboard/event';

export const useEvents = (disabled?: boolean) => {
  return useQuery({
    queryKey: ['events'] as const,
    queryFn: async () => {
      const response = await instances.userDashboard.get('events');
      return response.data as UserDashboardGetAllEventsResponseType;
    },
    retry: 1,
    staleTime: 30_000,
    refetchInterval: (query) => query.state.data?.ongoing.length ? 30_000 : false,
    enabled: disabled !== true,
  });
};
